import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* adminCoursSupprimerCoursSaga (action) {

    yield put(actions.adminCoursSupprimerCoursStart());

    const cours = action.payload.cours;

    try {
        const response = yield axios.delete(generateDynamicRoute(api.supprimerCours,[{toReplace:":coursId",value:cours}]));
        yield put(actions.adminCoursSupprimerCoursSuccess(response.data));
    } catch (error) {
        if(error.response) {
            yield put(actions.adminCoursSupprimerCoursFail(error.response.data.error));
        }else {
            yield put(actions.adminCoursSupprimerCoursFail("There's an error!"));
        }
    }
}

